<template>
  <div class="border-comp3">
    <div
      class="comp3-content"
      :style="{ backgroundColor: computedBg, border: '1px solid ' + computedBorder }"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BorderComp3',
  props: {
    borderColor: {
      type: String,
      default: ''
    },
    bgColor: {
      type: String,
      default: ''
    }
  },
  computed: {
    computedBorder() {
      return this.borderColor || 'var(--device-comp-border-color, #6076AD)';
    },
    computedBg() {
      return this.bgColor || 'var(--device-comp-bg, rgba(11, 21, 44, 0.6))';
    }
  }
};
</script>
<style lang="scss">
.border-comp3 {
  height: 100%;
  padding: 2px;
  background-image: url('~@/assets/image/lt.png'), url('~@/assets/image/rt.png'),
    url('~@/assets/image/lb.png'), url('~@/assets/image/rb.png'),
    url('~@/assets/image/linelight.png');
  background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat;
  background-position: top left, top right, bottom left, bottom right, center -5px;
  .comp3-content {
    height: 100%;
    box-sizing: border-box;
  }
}
</style>
